import React, {useContext, useState} from "react";
import {AppContext} from "../../App";
import {postRequest} from "../../helpers/APIHelper";
import Loading from "../Loading";
import Validator from "../Form/Validator";
import FormHelper from "../Form/FormHelper";

function SatisfactionForm() {
    const satisfactionFormDefault = {
        type: "",
        globalSatisfaction: "",
        communicationWithAgent: "",
        agentSkills: "",
        marketingSupportsSatisfaction: "",
        wouldYouRecommend: true,
        description: "",
        emailAdress: "",
        name: "",
        lastName: "",
        phoneNumber: "",
        rgpd: false
    };

    const fieldData = {
        type: {
            type: "select", title: "Type de bien vendu", required: true, default: satisfactionFormDefault.type, options: [
                {title: "Immeuble", value: "Immeuble"},
                {title: "Appartement", value: "Appartement"},
                {title: "Maison", value: "Maison"},
                {title: "Terrain", value: "Terrain"}
            ]
        },
        globalSatisfaction: {
            type: "select", title: "Satisfaction globale", required: true,
            default: satisfactionFormDefault.globalSatisfaction.type, options: [
                {title: "Très satisfait(e)", value: "Très satisfait"},
                {title: "Satisfait(e)", value: "Satisfait"},
                {title: "Neutre", value: "Neutre"},
                {title: "Insatisfait(e)", value: "Insatisfait"},
                {title: "Très insatisfait(e)", value: "Très insatisfait"}
            ]
        },
        communicationWithAgent: {
            type: "select", title: "Communication avec l’agent immobilier", required: true,
            default: satisfactionFormDefault.communicationWithAgent.type, options: [
                {title: "Très bonne", value: "Très bonne"},
                {title: "Bonne", value: "Bonne"},
                {title: "Moyenne", value: "Moyenne"},
                {title: "Mauvaise", value: "Mauvaise"},
                {title: "Très mauvaise", value: "Très mauvaise"}
            ]
        },
        agentSkills: {
            type: "select", title: "Compétence de l’agent immobilier", required: true,
            default: satisfactionFormDefault.agentSkills.type, options: [
                {title: "Très compétent(e)", value: "Très compétent"},
                {title: "Compétent(e)", value: "Compétent"},
                {title: "Moyennement compétent(e)", value: "Moyennement compétent"},
                {title: "Peu compétent(e)", value: "Peu compétent"},
                {title: "Pas du tout compétent(e)", value: "Pas du tout compétent"}
            ]
        },
        marketingSupportsSatisfaction: {
            type: "select", title: "Qualité des supports marketing (photos, annonces, etc.)", required: true,
            default: satisfactionFormDefault.marketingSupportsSatisfaction.type, options: [
                {title: "Très bonne", value: "Très bonne"},
                {title: "Bonne", value: "Bonne"},
                {title: "Moyenne", value: "Moyenne"},
                {title: "Mauvaise", value: "Mauvaise"},
                {title: "Très mauvaise", value: "Très mauvaise"}
            ]
        },
        wouldYouRecommend: {
            type: "toggle", title: "6. Recommanderiez-vous notre agence ?", required: true,
            default: satisfactionFormDefault.wouldYouRecommend, values: ["Oui", "Non"]
        },
        description: {
            type: "textarea", default: satisfactionFormDefault.description, required: true,
            title: "Décrivez en quelques lignes votre expérience avec FOTI Immobilier"
        },
        lastName: {type: "text", required: false, default: satisfactionFormDefault.lastName, title: "Nom"},
        name: {type: "text", required: false, default: satisfactionFormDefault.name, title: "Prénom"},
        phoneNumber: {
            type: "phone",
            required: false,
            default: satisfactionFormDefault.phoneNumber,
            title: "Téléphone (avec indicatif)"
        },
        emailAdress: {
            type: "email",
            required: false,
            default: satisfactionFormDefault.emailAdress,
            title: "Adresse e-mail"
        },
        rgpd: {
            type: "checkbox",
            required: true,
            default: satisfactionFormDefault.rgpd,
        },
    }

    const {setToastIsOpen, setToastMessage, setToastType} = useContext(AppContext);
    const [satisfactionForm, setSatisfactionForm] = useState(satisfactionFormDefault);

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState(null);

    function updateSatisfactionForm(field, value) {
        let tempSatisfactionForm = JSON.parse(JSON.stringify(satisfactionForm));

        tempSatisfactionForm[field] = value;

        setSatisfactionForm(tempSatisfactionForm);
    }

    function validate() {
        const validation = Validator.validate(satisfactionForm, fieldData);

        setErrors(validation);

        return !validation.hasErrors;
    }

    async function sendForm() {
        let toastType = "error";
        let toastMessage = "Des erreurs sont présentes dans le formulaire.";

        if (validate()) {
            setLoading(true);
            const {data, error} = await postRequest({endpoint: "/contact/satisfaction", body: satisfactionForm});
            setLoading(false);

            if (error)
                setErrors(error);
            else if (data.data.sent) {
                toastType = "sent";
                toastMessage = "Votre avis a été envoyé!";

                window.scrollTo(0,0);
                setSatisfactionForm(satisfactionFormDefault);
            }
        }

        setToastType(toastType);
        setToastMessage(toastMessage);
        setToastIsOpen(true);
    }

    return (
        <div className="container mx-auto w-4/5">
            <div className="flex flex-col justify-between">
                <div className="px-4 grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(fieldData).map((field, index) => (
                        <div key={index}
                             className={(fieldData[field].type !== "text" && fieldData[field].type !== "email" && fieldData[field].type !== "phone") ? "col-span-2" : ""}>
                            {(field !== "rgpd" && field !== "wouldYouRecommend") &&
                                <h3 className="block font-medium p-1 mb-2">
                                    {index + 1}. {fieldData[field].title} {fieldData[field].required && "*"}
                                </h3>
                            }
                            {FormHelper.getComponent(field, fieldData, satisfactionForm, updateSatisfactionForm, (errors && field in errors) ? errors[field] : null)}
                        </div>
                    ))}
                </div>
                <div className="flex justify-end">
                    <button onClick={sendForm}
                            className="text-white bg-primary hover:bg-white hover:text-primary border-2 border-primary px-2 py-1">
                        {loading ? <Loading page={false}/> : "Envoyer"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SatisfactionForm;
